import { getFirestore, collection, query, where, or, getDocs, onSnapshot } from "firebase/firestore"
import getCollectionPath from '@/services/firestore/getCollectionPath'
import catalogueCommands from '@/commands/catalogueCommands'
import depotCommands from '@/commands/depotCommands'

const db = getFirestore()
const collectionName = 'depot/'

function docToInstance(document) {
  const data = document.data()
  return data ? new Depot(document.id, data.name, data.ext, data.file, data.location, data.team, data.user, data.create_at) : null
}

export default class Depot {
  constructor(id, name, ext, file, location, team, user, create_at) {
    this.id = id
    this.name = name
    this.ext = ext
    this.file = file
    this.location = location
    this.team = team
    this.user = user
    this.create_at = create_at
  }

  async save() {
    const data = {
      name: this.name,
      ext: this.ext,
      file: this.file,
      location: this.location,
      team: this.team,
      user: this.user,
      create_at: new Date().getTime()
    }

    if (this.id) {
      await catalogueCommands.depot.update(this.id, data)
    } else {
      // Un dépôt est une action de participant : il passe par sa propre fonction, qui
      // déduit l'équipe et l'auteur du compte (la création du catalogue est réservée
      // aux administrateurs).
      const result = await depotCommands.submit({ areaId: this.location, name: this.name, ext: this.ext, file: this.file })
      this.id = result.id
    }
    return this
  }
  async delete() {
    await depotCommands.withdraw(this.id)
  }

  static async listenAll(callback) {
    const docsQuery = query(collection(db, await getCollectionPath(collectionName)))
    onSnapshot(docsQuery, snapshot => {
      const list = []
      snapshot.forEach(document => {
        list.push(docToInstance(document))
      })
      callback(list)
    })
  }
  static async listenByTeamAndAdmin(teamId, callback) {    
    const docsQuery = query(collection(db, await getCollectionPath(collectionName)),
      or(
        where('team', '==', teamId),
        where('team', '==', 'ADMIN')
      )
    )
    onSnapshot(docsQuery, snapshot => {
      const list = []
      snapshot.forEach(document => {
        list.push(docToInstance(document))
      })
      callback(list)
    })
  }
  static async listenByTeam(teamId, callback) {
    const docsQuery = query(
      collection(db, await getCollectionPath(collectionName)),
      where('team', '==', teamId)
    )
    onSnapshot(docsQuery, snapshot => {
      const list = []
      snapshot.forEach(document => {
        list.push(docToInstance(document))
      })
      callback(list)
    })
  }

  static async getAll(){
    const documents = await getDocs(collection(db, await getCollectionPath(collectionName)))
    return documents.docs.map(docToInstance)
  }

  /**
   * Dépôts d'une équipe, en une lecture.
   * Un participant n'a pas accès à l'ensemble de la collection : la requête est donc
   * restreinte à son équipe, comme le fait déjà l'écran des dépôts.
   */
  static async getByTeam(teamId){
    const documents = await getDocs(query(
      collection(db, await getCollectionPath(collectionName)),
      where('team', '==', teamId),
    ))
    return documents.docs.map(docToInstance)
  }

}